import clsx from "clsx";
import { RichTextContent } from "contentful";
import { useRouter } from "next/router";
import LinkComponent from "@Components/Link";
import { Button } from "@Components/ui";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import { useCustomer } from "@wff/hooks/useCustomer";
import { useLocaleRouter } from "@wff/hooks/useLocaleRouter";
import classes from "./MembershipTable.module.scss";
interface MembershipTableProps {
  content: RichTextContent;
  children?: React.ReactNode;
  className?: string;
  signUpButtonLabel?: string;
}

const MembershipTable = ({
  content,
  className = "",
  children,
  signUpButtonLabel,
}: MembershipTableProps) => {
  const router = useRouter();
  const { getLocalePath } = useLocaleRouter();
  const { isLoggedIn } = useCustomer();

  return (
    <div className={clsx(classes["table-become-a-member"], className)}>
      <CmsTextEditorContent content={content} />
      {children}
      {router.asPath.includes("become-a-member") ? (
        <LinkComponent
          href={getLocalePath(
            `/account${
              isLoggedIn
                ? "?tab=membership"
                : "/login?to=/account?tab=membership"
            }`
          )}
        >
          <Button className="action action--primary">
            {signUpButtonLabel}
          </Button>
        </LinkComponent>
      ) : null}
    </div>
  );
};

export default MembershipTable;
